import * as React from "react";
import {DistanceComponent, DurationComponent} from "components/Map/CarDetails/Composites/_CompositesHelpers";

export const HistoryRidesHeading = (props: { totalDistanceKilometers: number; totalDurationSeconds: number }) => {
  return (
    <div className="ride-history__heading">
      <DurationComponent durationSeconds={props.totalDurationSeconds}/>
      <DistanceComponent mileage={props.totalDistanceKilometers}/>
    </div>
  );
};

export default HistoryRidesHeading



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/Components/HistoryRidesHeading.Component.tsx